var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import Service, { inject as service } from '@ember/service';
import SqOneTrust from '@square/one-trust';
import CDP, { EntityTypes } from '@squareup/cdp';
import EventstreamClient from 'eventstream.js';
import { FlagNames } from './ember-multipass-flag';
const CDP_PROD_API_KEY = Object.freeze({
  PRODUCTION: '6c294f35-6704-42cd-9105-d087b8265b10',
  OTHER: '3ac24ad1-1049-465f-b3b8-7b82a9eb156e'
});
const QUERY_PARAMS_TO_REDACT = Object.freeze(['v', 'national_phone_number']);

/**
 * Track event data to Square analytics data warehouses.
 *
 * ES2 SDK: https://github.com/squareup/js-sq-ember-eventstream
 * CDP SDK: https://zeroheight.com/55c402603/p/892ab3-client-libraries/b/5417d3
 */
let TrackingService = (_dec = service('eventstream'), _dec2 = service('ember-multipass-eventstream'), _dec3 = service('ember-multipassfe-client'), _dec4 = service('ember-multipass-config'), _dec5 = service('ember-multipass-logging'), _dec6 = service('ember-multipass-flag'), _class = class TrackingService extends Service {
  constructor() {
    super(...arguments);
    _defineProperty(this, "BUTTON_CLICK_ACTION_NAME", 'button-click');
    _defineProperty(this, "LINK_CLICK_ACTION_NAME", 'link-click');
    _initializerDefineProperty(this, "cookies", _descriptor, this);
    _initializerDefineProperty(this, "router", _descriptor2, this);
    _initializerDefineProperty(this, "hostEventstream", _descriptor3, this);
    _initializerDefineProperty(this, "eventstream", _descriptor4, this);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor5, this);
    _initializerDefineProperty(this, "multipassConfig", _descriptor6, this);
    _initializerDefineProperty(this, "logger", _descriptor7, this);
    _initializerDefineProperty(this, "flags", _descriptor8, this);
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "dataApi", void 0);
    _defineProperty(this, "initialized", false);
    _defineProperty(this, "cdpSessionToken", void 0);
    _defineProperty(this, "userIsActive", false);
    _defineProperty(this, "userActiveEvents", ['load', 'click', 'keypress', 'touchstart', 'mousemove', 'mousedown', 'scroll']);
    _defineProperty(this, "userActiveTimerId", void 0);
    _defineProperty(this, "heartbeatIntervalId", void 0);
    _defineProperty(this, "heartbeatInterval", void 0);
    this.config = getOwner(this).resolveRegistration('config:environment');

    // Initialize ES2
    // Inherit eventstream client from main app if it's available
    // It could be from `sq-ember-eventstream` or main app's `service:eventstream`
    const hostEsClient = this.hostEventstream?.client || getOwner(this).lookup('eventstream-client:main');
    if (hostEsClient) {
      this.eventstream.client = hostEsClient;
    } else {
      this.logger.sentryMessage(`Failed to find main app eventstream client - ${this.config.APP?.name}`);
      this.eventstream.client = new EventstreamClient({
        applicationName: this.config.eventstream?.name || this.config.APP?.name || 'ember-multipass-tracking',
        environment: this.config.eventstream?.environment || this.multipassConfig.environment
      });
    }

    // Disable ES2 console logs in production
    if (this.multipassConfig.environment === 'production') {
      this.eventstream.debug = () => true;
    }

    // Initialize CDP
    this.dataApi = new CDP({
      apiKey: this.cdpKey,
      environment: this.multipassConfig.environment,
      application: {
        name: 'multipassui'
      },
      useSameOrigin: ['staging', 'production'].includes(this.multipassConfig.environment) && this.multipassfeClient.isAppHostname
    });
    if (this.shouldTrack) {
      const avt = this.cookies.read('_savt') || this.multipassfeClient.createUUID();
      this.dataApi.identifyStrict({
        entityType: EntityTypes.anonVisitor,
        entityId: avt
      });
    }
    this.handleUserIsActive = this.handleUserIsActive.bind(this);
    this.initialized = true;
  }
  get cdpKey() {
    if (this.multipassConfig.environment === 'production') {
      return CDP_PROD_API_KEY.PRODUCTION;
    }
    return CDP_PROD_API_KEY.OTHER;
  }
  get redactedEventStream2Fields() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      webpage_full_url: redactedURLResult.url,
      webpage_search: redactedURLResult.search
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.webpage_referrer = redactedReferrerURLResult.url;
    }
    return result;
  }
  get redactedCDPContext() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      page: {
        url: redactedURLResult.url,
        search: redactedURLResult.search
      }
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.referrer = {
        referrer: redactedReferrerURLResult.url,
        referrerSearch: redactedReferrerURLResult.search
      };
      result.page.referrer = redactedReferrerURLResult.url;
    }
    if (this.cdpSessionToken) {
      result.page.session_token = this.cdpSessionToken;
    }
    return result;
  }
  get redactedCDPProperties() {
    const redactedURLResult = this.redactQueryParams(this.getCurrentPageUrl(), QUERY_PARAMS_TO_REDACT);
    const result = {
      url: redactedURLResult.url,
      search: redactedURLResult.search
    };
    if (this.getCurrentReferrerUrl()) {
      const redactedReferrerURLResult = this.redactQueryParams(this.getCurrentReferrerUrl(), QUERY_PARAMS_TO_REDACT);
      result.referrer = redactedReferrerURLResult.url;
    }
    return result;
  }
  get shouldTrack() {
    const sqOneTrust = new SqOneTrust();
    return this.initialized && ['staging', 'production'].includes(this.multipassConfig.environment) && !sqOneTrust.retargetingOrAdvertisingCookiesBlocked;
  }
  getCurrentPageUrl() {
    return window.location.href;
  }
  getCurrentReferrerUrl() {
    return document.referrer;
  }
  trackLinkClick(data) {
    this.trackPageClick(this.LINK_CLICK_ACTION_NAME, data);
  }
  trackButtonClick(data) {
    this.trackPageClick(this.BUTTON_CLICK_ACTION_NAME, data);
  }
  trackPageClick(action, {
    elementText,
    elementTitle,
    elementIdentifier,
    elementType
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    const trackingPayload = {
      page_click_action: action,
      page_click_description: elementText,
      element_text: elementText,
      element_identifier: elementIdentifier,
      element_title: elementTitle,
      element_type: elementType
    };
    this.eventstream.trackPageClick({
      ...trackingPayload,
      ...this.redactedEventStream2Fields
    });
    this.dataApi?.track('page click', {
      ...trackingPayload,
      ...this.redactedCDPProperties
    }, this.redactedCDPContext);
  }
  trackRoute({
    pageTitle
  } = {}) {
    this.cdpSessionToken = this.multipassfeClient.createUUID();
    this.trackPageView({
      pageTitle
    });
    this.trackHeartbeat();
  }
  trackEvent(action, {
    elementIdentifier,
    elementType,
    previousValue,
    newValue,
    ...additionalProperties
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    const trackingPayload = {
      action,
      element_identifier: elementIdentifier,
      element_type: elementType,
      previous_value: previousValue,
      new_value: newValue,
      ...additionalProperties
    };
    this.eventstream.trackPageClick({
      ...trackingPayload,
      ...this.redactedEventStream2Fields
    });
    this.dataApi?.track(action, {
      ...trackingPayload,
      ...this.redactedCDPProperties
    }, this.redactedCDPContext);
  }
  trackPageView({
    pageTitle,
    pageDescription
  } = {}) {
    if (!this.shouldTrack) {
      return;
    }
    const es2Opts = this.redactedEventStream2Fields;
    const cdpProperties = this.redactedCDPProperties;
    if (pageTitle) {
      es2Opts['webpage_title'] = pageTitle;
      cdpProperties.title = pageTitle;
    }
    if (pageDescription) {
      es2Opts.page_view_description = pageDescription;
      cdpProperties.description = pageDescription;
    }
    const routeName = this.router.currentRouteName;
    this.eventstream.trackPageView(routeName, es2Opts);
    this.dataApi?.page(routeName, cdpProperties, this.redactedCDPContext);
  }

  /**
   * Maintain user's active state by listening certain events
   * If user is active, send heartbeat event to CDP every interval_seconds
   */
  trackHeartbeat() {
    this.stopHeartbeat();
    const intervalSeconds = this.flags.getValue(FlagNames.CDP_HEARTBEAT_INTERVAL_SECONDS);
    if (!intervalSeconds || typeof intervalSeconds !== 'number' || intervalSeconds < 0) {
      return;
    }
    this.heartbeatInterval = intervalSeconds * 1000;
    this.trackIsUserActive();
    this.cdpTrackHeartbeat();
    this.heartbeatIntervalId = setInterval(() => {
      if (this.userIsActive) {
        this.cdpTrackHeartbeat();
      }
    }, this.heartbeatInterval);
  }
  cdpTrackHeartbeat() {
    if (!this.shouldTrack) {
      return;
    }
    const cdpContext = {
      integrations: {
        all: false,
        snowflake: true
      }
    };
    this.dataApi?.track('Heartbeat', {
      square_geo: this.cookies.read('squareGeo')
    }, {
      ...cdpContext,
      ...this.redactedCDPContext
    });
  }
  trackIsUserActive() {
    this.userActiveEvents.forEach(event => {
      window.addEventListener(event, this.handleUserIsActive, true);
    });
  }
  handleUserIsActive() {
    clearTimeout(this.userActiveTimerId);
    this.userIsActive = true;
    // set new timer to inactivate user
    this.userActiveTimerId = setTimeout(() => {
      this.userIsActive = false;
    }, this.heartbeatInterval);
  }

  /**
   * Remove all the listeners and timers from the previous tracked route
   */
  stopHeartbeat() {
    this.userActiveEvents.forEach(event => {
      window.removeEventListener(event, this.handleUserIsActive, true);
    });
    clearInterval(this.heartbeatIntervalId);
    clearTimeout(this.userActiveTimerId);
  }

  /**
   * [VULN-63269]/[INV-647] To support redacting sensitive query strings from URL.
   *
   * @typedef {Object} RedactionResult
   * @property {string} url - URL string
   * @property {string|undefined} search - Search string
   *
   * @param inputUrl {string}
   * @param queryParamsToRedact {string[]}
   * @returns {RedactionResult} result
   */
  redactQueryParams(inputUrl, queryParamsToRedact) {
    try {
      const url = new URL(inputUrl);
      const originalParams = url.searchParams;
      for (const param of queryParamsToRedact) {
        if (originalParams.has(param)) {
          originalParams.set(param, 'REDACTED_TOKEN');
        }
      }
      return {
        url: url.toString(),
        search: url.search
      };
    } catch (e) {
      return {
        url: inputUrl,
        search: undefined
      };
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "cookies", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hostEventstream", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "multipassConfig", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "flags", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { TrackingService as default };